import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';

export const Schema = Yup.object().shape({
});

export const NationalitySubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
            <Form.Group as={Col} controlId="formNationality">
                    <Form.Label>Nationalität</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="nationality"
                        value={values.nationality}
                        isValid={touched.nationality && !errors.nationality}
                        isInvalid={touched.nationality && errors.nationality}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.Nationality.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.nationality}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};